import { render, staticRenderFns } from "./AudioTracks.vue?vue&type=template&id=5c5f2f10&"
import script from "./AudioTracks.vue?vue&type=script&lang=js&"
export * from "./AudioTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports